"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = exports.ContractState = void 0;
const crypto_1 = require("@akord/crypto");
const bad_request_1 = require("../errors/bad-request");
class ContractState extends crypto_1.Encryptable {
}
__decorate([
    (0, crypto_1.encrypted)()
], ContractState.prototype, "name", void 0);
exports.ContractState = ContractState;
class Tag {
    /**
     * @param name
     * @param value
     * @returns
     */
    constructor(name, value) {
        if (!name) {
            throw new bad_request_1.BadRequest("Missing tag name.");
        }
        if (!value) {
            throw new bad_request_1.BadRequest("Missing tag value for: " + name);
        }
        return {
            name: name,
            value: value.toString()
        };
    }
}
exports.Tag = Tag;
